export default "__VITE_ASSET__CG2w9ARi__"